__turbopack_context__.v({
  "drawDetailContainer": "DrawDetails-module__eT_M0q__drawDetailContainer",
});
